import { render, staticRenderFns } from "./TicketSubmission.vue?vue&type=template&id=5ab82e1a&scoped=true"
import script from "./TicketSubmission.vue?vue&type=script&lang=js"
export * from "./TicketSubmission.vue?vue&type=script&lang=js"
import style0 from "./TicketSubmission.vue?vue&type=style&index=0&id=5ab82e1a&prod&lang=css"
import style1 from "./TicketSubmission.vue?vue&type=style&index=1&id=5ab82e1a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ab82e1a",
  null
  
)

export default component.exports